import { nFormatter } from "@asayinc/component-library";
import { IAllNetworkLocationStats } from "../../../../../../../store/allNetworkStats";

/**
 * Parse network location data to show top 3 locations with customer counts
 * No percentages, just raw counts formatted nicely
 */
export const parseNetworkLocationData = (
  locationData: IAllNetworkLocationStats | undefined
) => {
  if (locationData?.shareholders) {
    // Sort by totalCustomers descending and take top 3
    const sortedLocations = [...locationData.shareholders]
      .sort((a, b) => b.totalCustomers - a.totalCustomers)
      .slice(0, 3);

    return sortedLocations.map((location) => ({
      title: location.location,
      value: nFormatter(location.totalCustomers),
    }));
  }
  return [];
};

/**
 * Parse network location shares data to show top 3 locations with share counts
 * Formatted nicely using nFormatter
 */
export const parseNetworkLocationSharesData = (
  locationData: IAllNetworkLocationStats | undefined
) => {
  if (locationData?.shares) {
    // Sort by totalShares descending and take top 3
    const sortedLocations = [...locationData.shares]
      .sort((a, b) => parseFloat(b.totalShares) - parseFloat(a.totalShares))
      .slice(0, 3);

    return sortedLocations.map((location) => ({
      title: location.location,
      value: nFormatter(parseFloat(location.totalShares)),
    }));
  }
  return [];
};
